import { alpha, Theme } from '@mui/material/styles';

import { getAppTokens } from '@mightyhive/theme';

import { homePalette } from './homePalette';

export interface HomeTokens {
  pageGradient: string;
  pageGradientFallback: string;
  greetingColor: string;
  pageHeadingColor: string;
  pageSubtitleColor: string;
  hubCardBackground: string;
  hubCardHoverBackground: string;
  hubCardBorder: string;
  hubCardTitleColor: string;
  hubCardBodyColor: string;
  hubStepBadgeBorder: string;
  hubStepBadgeColor: string;
  hubCtaBackground: string;
  hubCtaColor: string;
  hubCtaHoverBackground: string;
}

export const getHomeTokens = (theme: Theme): HomeTokens => {
  const appTokens = getAppTokens(theme);

  return {
    pageGradient: appTokens.pageGradient,
    pageGradientFallback: appTokens.pageGradientFallback,
    greetingColor: appTokens.pageSubtitleColor,
    pageHeadingColor: appTokens.pageHeadingColor,
    pageSubtitleColor: appTokens.pageSubtitleColor,
    hubCardBackground: alpha(theme.palette.common.white, homePalette.hubCardBackgroundOpacity),
    hubCardHoverBackground: alpha(theme.palette.common.white, homePalette.hubCardHoverBackgroundOpacity),
    hubCardBorder: homePalette.hubCardBorder,
    hubCardTitleColor: homePalette.hubTitle,
    hubCardBodyColor: appTokens.pageSubtitleColor,
    hubStepBadgeBorder: homePalette.hubStepBadgeBorder,
    hubStepBadgeColor: appTokens.pageSubtitleColor,
    hubCtaBackground: theme.palette.common.white,
    hubCtaColor: appTokens.pageHeadingColor,
    hubCtaHoverBackground: homePalette.hubCtaHover,
  };
};
